import { useContext } from 'react';
import { MdLock, MdVisibility, MdSouthAmerica } from 'react-icons/md';
import { VisibilityModalContext } from '../../../pages/Registration/VisibilityModalContext';
import { FormFieldVisibility } from '../FormLabel/FormFieldVisibility';

export const VisibilityIcon = ({ visibility }: { visibility?: FormFieldVisibility }) => {
  const { setShowVisibilityModal } = useContext(VisibilityModalContext);

  const Container = ({ children }: { children: React.ReactNode }) => (
    <button
      style={{ all: 'unset', cursor: 'help' }}
      className="ms-1"
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        setShowVisibilityModal?.(true);
      }}
    >
      {children}
    </button>
  );

  if (!visibility) {
    return null;
  }

  if (visibility === 'public') {
    return (
      <Container>
        <MdSouthAmerica title="Visible to everyone" />
      </Container>
    );
  }

  if (visibility === 'connected') {
    return (
      <Container>
        <MdVisibility title="Visible by Health Entities connected with you" />
      </Container>
    );
  }

  return (
    <Container>
      <MdLock title="Visible by SendIt Staff" />
    </Container>
  );
};
